import {
  DocumentActions,
  DocumentActionTypes,
  DocumentStateChangeAction,
} from './document.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

export interface FirestoreDocumentState {
  [collectionPath: string]: EntityState<any>;
}

export const firestoreDocumentInitialState: FirestoreDocumentState = {};

const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export function isDocumentStateChangeAction(
  action: Action,
): action is DocumentStateChangeAction {
  return ([
    DocumentActionTypes.Modified,
    DocumentActionTypes.Added,
    DocumentActionTypes.Removed,
    DocumentActionTypes.Load,
    DocumentActionTypes.Clear,
    DocumentActionTypes.AddMany,
  ] as string[]).includes(action.type);
}

export function getEntityState(
  state: FirestoreDocumentState,
  action: DocumentStateChangeAction,
): EntityState<any> {
  if (!state.hasOwnProperty(action.collectionPath)) {
    return adapter.getInitialState();
  }

  return state[action.collectionPath];
}

export function firestoreDocumentReducer(
  state: FirestoreDocumentState = firestoreDocumentInitialState,
  action: DocumentActions<any, any>,
): FirestoreDocumentState {
  if (isDocumentStateChangeAction(action)) {
    let collectionState = getEntityState(state, action);

    switch (action.type) {
      case DocumentActionTypes.Added:
      case DocumentActionTypes.Modified:
        collectionState = adapter.upsertOne(action.document, collectionState);
        break;

      case DocumentActionTypes.Removed:
        collectionState = adapter.removeOne(action.id, collectionState);
        break;

      case DocumentActionTypes.AddMany:
        if (action.documents.length) {
          collectionState = adapter.upsertMany(
            action.documents,
            collectionState,
          );
        }
        break;

      case DocumentActionTypes.Clear:
        if (state.hasOwnProperty(action.collectionPath)) {
          const clone = { ...state };
          delete clone[action.collectionPath];
          return clone;
        }
        break;
    }

    return { ...state, [action.collectionPath]: collectionState };
  } else {
    switch (action.type) {
      case DocumentActionTypes.ClearAll:
        return Object.keys(state)
          .filter((path) => (action.withOut || []).includes(path))
          .reduce((acc, key) => ({ ...acc, [key]: state[key] }), {});

      default:
        return state;
    }
  }
}
